import GridItem from "../grid/GridItem";

const TableWrapper = ({columns, setColumns, disabled}) => {

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-6 py-6">
            {columns.map((colData, idx) => (
                <div key={idx}>
                    {colData.map((faq, i) => (
                        <GridItem key={i} faq={faq} i={idx} j={i} setColumns={setColumns} columns={columns} disabled={disabled}/>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default TableWrapper;
